// src/admin/AdminGate.jsx
import React from "react";
import axios from "axios";
import AdminLogin from "./AdminLogin";
import API_BASE_URL from "../config/apiConfig";

export default function AdminGate({ children }) {
  const [status, setStatus] = React.useState("checking");

  const validateSession = React.useCallback(async () => {
    const token = localStorage.getItem("adminToken");
    if (!token) {
      setStatus("login");
      return;
    }
    setStatus("checking");
    try {
      await axios.get(`${API_BASE_URL}/api/admin/auth/validate`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setStatus("authenticated");
    } catch {
      localStorage.removeItem("adminToken");
      setStatus("login");
    }
  }, []);

  React.useEffect(() => {
    validateSession();
  }, [validateSession]);

  if (status === "checking") {
    return <div className="container py-5 text-center">Checking Admin session...</div>;
  }
  return status === "authenticated"
    ? children
    : <AdminLogin onSuccess={validateSession} />;
}
